// Renders a list of reports of a single visit. Viewed at route /reports.

import React, { PureComponent, Fragment } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import PropTypes from 'prop-types'
import { forEach } from 'lodash'
import List from '../../components/List'
import Button from '../../components/Button'
import Spinner from '../../components/Spinner'
import config from '../../config/app'
import {
  setActiveVisit,
  apiRequest,
  highlightNavbarSection,
  changeRoute
} from '../../root/actions'
import { dispatch } from '../../root/store'
import { VISIT_URL } from '../../api/endpoints'
import style from './style'

export class Reports extends PureComponent {
  constructor (props) {
    super(props)
    this.isVisitLoaded = this.isVisitLoaded.bind(this)
  }

  isVisitLoaded () {
    return (
      this.props.activeVisit &&
      this.props.activeVisit.uuid === this.props.match.params.id
    )
  }

  componentDidMount () {
    document.querySelector('.main-content').scrollTop = 0

    if (!this.isVisitLoaded()) {
      const uuid = this.props.match.params.id
      const request = {
        url: `${VISIT_URL}/${uuid}`,
        method: 'get'
      }

      const meta = {
        Component: 'Report',
        assert: {
          item: uuid,
          test: 'isString'
        },
        onSuccess: result => {
          dispatch(setActiveVisit(result))
          const isCurrentVisit =
            this.props.currentVisit !== null &&
            this.props.currentVisit.uuid === result.data.data.uuid
          if (isCurrentVisit) {
            dispatch(highlightNavbarSection('currentReport'))
          } else {
            dispatch(highlightNavbarSection('history'))
          }
        }
      }
      dispatch(apiRequest(request, meta))
    }
  }

  render () {
    if (!this.isVisitLoaded()) {
      return <Spinner />
    }

    const {
      classes,
      isMobile,
      activeVisit,
      activeReports,
      currentVisit,
      user
    } = this.props

    const headshotUrl = activeVisit.reportCard.demographics.headshot
    const headshotStyle = { backgroundImage: `url(${headshotUrl})` }
    const isCurrentVisit =
      currentVisit !== null && currentVisit.uuid === activeVisit.uuid

    const items = []

    forEach(activeReports, (value, key) => {
      const report = {
        title: value._meta.title,
        icon: value._meta.icon,
        route: `/visits/${activeVisit.uuid}/reports/${
          value._meta.originalTitle
        }`,
        hideOnMobile: true
      }
      if (config.reports.includes(value._meta.title)) items.push(report)
    })

    const listProps = {
      items,
      action: this.props.changeRoute,
      className: 'mobile-padding',
      isNoTopBorder: true
    }

    const userName = user.full_name
    const pageTitle = isCurrentVisit ? 'Current Report' : 'Past Report'

    return (
      <div className={`${classes.base}`}>
        <Fragment>
          <div className="date-container">
            <h2 className="mobile-padding ">{pageTitle}</h2>

            {isMobile && (
              <div className="mobile-padding ">
                <div className="profileVisit">Visit on:</div>
                <div className="profileDate">
                  {activeVisit.dayFormattedDate}
                </div>
              </div>
            )}
          </div>
          <div className="details-container">
            <div className="profileContainer">
              <div className="flex profileArea">
                <div className="profile-headshot">
                  <div className="headshot-image" style={headshotStyle} />
                </div>
                <div className="flexCenter">
                  <div>
                    <h1>{userName}</h1>
                    {!isMobile && (
                      <Fragment>
                        <div className="profileVisit">Visit on:</div>
                        <div className="profileDate">
                          {activeVisit.dayFormattedDate}
                        </div>
                      </Fragment>
                    )}
                  </div>
                </div>
              </div>

              {!isMobile ? (
                <div className="flexCenter">
                  <a href={activeVisit.reportPdf}>
                    <Button scheme="light">Download Health Report</Button>
                  </a>
                </div>
              ) : null}
            </div>

            <br />
            {isMobile ? (
              <div className="mobile-padding">
                <a href={activeVisit.reportPdf}>
                  <Button scheme="light">Download Health Report</Button>
                </a>
              </div>
            ) : null}
            <br />
            <List {...listProps} />
            <br />
            <br />
          </div>
        </Fragment>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeVisit: state.containers.app.get('activeVisit'),
    currentVisit: state.containers.app.get('currentVisit'),
    activeReports: state.containers.app.get('activeReports'),
    currentReport: state.containers.app.get('currentReport'),
    user: state.containers.app.get('user'),
    isMobile: state.containers.app.get('isMobile')
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ changeRoute }, dispatch)
}

Reports.propTypes = {
  activeVisit: PropTypes.object,
  activeReports: PropTypes.object,
  currentVisit: PropTypes.object,
  user: PropTypes.object,
  isMobile: PropTypes.bool,
  match: PropTypes.object,
  changeRoute: PropTypes.func,
  classes: PropTypes.object
}

const styleAndTheme = theme => style

export default injectSheet(styleAndTheme)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Reports)
)
